import React, { useRef } from 'react'

import { IToolHandler } from '../types'

import Counter from './toggles/Counter'
import { Tools } from './toolbarInterfaces'
import ToolItem from './ToolItem'

import cm from './ToolsList.module.css'

export interface IToolbarProps {
  tools: Tools[]
  onInsert: IToolHandler
  selectedTool: string | null
  onSelectTool: (tool: string) => void
  focusEditor: () => void
}

const ToolsList = ({ selectedTool, onSelectTool, tools, onInsert, focusEditor }: IToolbarProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  return (
    <div ref={wrapperRef} className={cm.toolsList}>
      {tools.map((tool) => (
        <ToolItem
          key={tool}
          tool={tool}
          isSelected={tool === selectedTool}
          onSelect={onSelectTool}
          onInsert={onInsert}
          focusEditor={focusEditor}
          toolbarRef={wrapperRef}
        />
      ))}

      <Counter />
    </div>
  )
}

export default ToolsList
